export const getGroupDefaultValues = (groupId?: string | null) => {
  return {
    group: {
      id: groupId,
    },
  }
}
